"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
function ILProgressBar(_a) {
    var _b;
    var className = _a.className, sx = _a.sx, progressPercent = _a.progressPercent, delayPercent = _a.delayPercent, _c = _a.hideGuide, hideGuide = _c === void 0 ? false : _c, children = _a.children, props = __rest(_a, ["className", "sx", "progressPercent", "delayPercent", "hideGuide", "children"]);
    var classes = 'il-progress-bar ' + className;
    var noProgress = progressPercent === 0;
    var fullProgress = Number(progressPercent + (delayPercent || 0)) >= 100;
    var height = (_b = props.height) !== null && _b !== void 0 ? _b : 8;
    var hasDelay = !!delayPercent && delayPercent > 0 && progressPercent < 100;
    if (progressPercent + (delayPercent || 0) > 100) {
        console.error('[ILProgressBar] - Please check if you provide valid values for progress bar');
    }
    return (react_1.default.createElement(material_1.Box, { className: classes, sx: __assign({ display: 'flex', position: 'relative', border: 'solid 0.7px #e0e9ef', height: height, borderRadius: '8px', backgroundColor: 'background.default' }, sx) },
        react_1.default.createElement(material_1.Box, { sx: __assign({ backgroundColor: 'primary.light', width: "".concat(progressPercent, "%"), borderTopLeftRadius: '8px', borderBottomLeftRadius: '8px' }, (fullProgress &&
                progressPercent >= 100 && {
                borderTopRightRadius: '8px',
                borderBottomRightRadius: '8px',
            })) }),
        hasDelay && !noProgress && (react_1.default.createElement(material_1.Box, { sx: {
                backgroundColor: 'primary.light',
                width: 6,
                ml: '-3px',
                borderTopRightRadius: '50%',
                borderBottomRightRadius: '50%',
                zIndex: 1,
            } })),
        hasDelay && (react_1.default.createElement(material_1.Box, { sx: __assign(__assign(__assign({ backgroundColor: 'error.main', width: "".concat(delayPercent, "%"), opacity: 0.6 }, (fullProgress && {
                borderTopRightRadius: '8px',
                borderBottomRightRadius: '8px',
            })), (!noProgress && {
                ml: '-3px',
            })), (noProgress && {
                borderTopLeftRadius: '8px',
                borderBottomLeftRadius: '8px',
            })) })),
        !hideGuide && (react_1.default.createElement(material_1.Box, { className: "guide", sx: {
                height: "calc(1.4 * ".concat(height, ")"),
                width: '1px',
                marginTop: '-2px',
                backgroundColor: hasDelay ? 'error.main' : 'primary.dark',
            } })),
        children));
}
exports.default = ILProgressBar;
